// Progression system configuration
// This can be easily modified for testing and rollout

export const PROGRESSION_CONFIG = {
  // Feature flags
  ENABLED: true, // Set to true to enable progressions
  DEBUG: true,    // Set to true for debug logging
  
  // Rollout settings
  ROLLOUT_PERCENTAGE: 20, // Percentage of users to show progressions to
  
  // UI settings
  SHOW_PROGRESSION_STATS: true,
  MAX_PROGRESSIONS_DISPLAYED: 6,
  
  // Testing settings
  FORCE_ENABLE_FOR_TESTING: false, // Set to true to force enable for testing
};

// Helper function to check if progressions should be shown
export const shouldShowProgressions = (userId = null) => {
  // Force enable for testing
  if (PROGRESSION_CONFIG.FORCE_ENABLE_FOR_TESTING) {
    return true;
  }
  
  // Check if feature is enabled
  if (!PROGRESSION_CONFIG.ENABLED) {
    return false;
  }
  
  // For now, show to all users if enabled
  // Later we can add user-based rollout logic
  return true;
};

// Debug logging
export const logProgressionDebug = (message, data = null) => {
  if (PROGRESSION_CONFIG.DEBUG) {
    console.log(`[Progression Debug] ${message}`, data);
  }
};
